module.exports = __webpack_public_path__ + "static/media/Prince.da8fd0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Prince.png
// module id = 390
// module chunks = 0